import React, { Suspense, lazy } from 'react';
import { useLanguage } from '../context/LanguageContext';
import TextLogo from './TextLogo';

const Spline = lazy(() => import('@splinetool/react-spline'));

const HeroSection = () => {
  const { t, isRTL } = useLanguage();

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      {/* 3D Background */}
      <div className="absolute inset-0 z-0">
        <Suspense fallback={
          <div className="w-full h-full bg-black flex items-center justify-center">
            <div className="animate-pulse text-white/30">Loading...</div>
          </div>
        }>
          <Spline 
            scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" 
            style={{ width: '100%', height: '100%' }}
          />
        </Suspense>
      </div>

      {/* Overlay for better text visibility */}
      <div className="absolute inset-0 bg-black/50 z-10"></div>

      {/* Content */}
      <div className="relative z-20 text-center px-6 max-w-4xl mx-auto">
        <div className="mb-8 animate-fade-in">
          <TextLogo size="large" />
        </div>
        
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 animate-slide-up">
          {t.hero.title}
        </h1>
        
        <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto animate-slide-up-delay">
          {t.hero.subtitle}
        </p>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/50 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
